import { useCookies } from "react-cookie";

const COOKIE_KEY = "selectedFiltersOrReporting";
const COOKIE_OPTIONS = {
  path: "/",
  maxAge: 604800,
};

export const useSelectedFiltersOrReportingCookie = () => {
  const [cookies, setCookies, removeCookie] = useCookies([COOKIE_KEY]);

  const getSelectedFiltersOrReporting = () => {
    return cookies[COOKIE_KEY] || {};
  };

  const updateSelectedFiltersOrReporting = (updates) => {
    const current = getSelectedFiltersOrReporting();
    const updated = { ...current, ...updates };
    setCookies(COOKIE_KEY, updated, COOKIE_OPTIONS);

    return updated;
  };

  const removeSelectedFiltersOrReporting = (key) => {
    const current = getSelectedFiltersOrReporting();
    const { [key]: _, ...rest } = current;
    setCookies(COOKIE_KEY, rest, COOKIE_OPTIONS);

    return rest;
  };

  const clearSelectedFiltersOrReporting = () => {
    removeCookie(COOKIE_KEY, { path: "/" });
  };

  return {
    selectedFiltersOrReporting: getSelectedFiltersOrReporting(),
    updateSelectedFiltersOrReporting,
    removeSelectedFiltersOrReporting,
    clearSelectedFiltersOrReporting,
  };
};
